module.exports = __webpack_public_path__ + "static/descriptive-icons-mobile-0b6f9ce56cb9a949894877f52d289dd0.png";